import React from "react";
import SuccessContainer from "./SuccessContainer";
import PropTypes from "prop-types";
import FailContainer from "./FailContainer";

export default function FileDropRespondContainer({ file, status, id, queues }) {
  return (
    <div>
      {["Success", "Skipped"].includes(status) ? (
        <SuccessContainer
          file={file}
          id={id}
          queues={queues}
          isSkipped={status === "Skipped"}
        />
      ) : (
        <FailContainer file={file} id={id} />
      )}
    </div>
  );
}

FileDropRespondContainer.propTypes = {
  id: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  file: PropTypes.oneOfType([
    PropTypes.shape({
      lastModified: PropTypes.number,
      name: PropTypes.string,
      size: PropTypes.number,
      type: PropTypes.string,
    }),
    PropTypes.instanceOf(null),
  ]),
  queues: PropTypes.shape({
    scriptsQueue: PropTypes.arrayOf(PropTypes.object),
    filesQueue: PropTypes.arrayOf(PropTypes.object),
  }),
};
